<script setup>

import PriceFormatter from "@/components/PriceFormatter.vue";
import {useOrderDataStore} from "@/stores/orderDataStore";
import {useI18n} from "vue-i18n";


const orderDataStore = useOrderDataStore();
const {t} = useI18n();

</script>

<template>
  <div class="flex items-start space-x-9 responsive-body-small">
    <div>
      <span class="block font-bold responsive-body-medium">{{ t('returnToCard') }}</span>
      <span v-if="orderDataStore.shippingCountry==='GR'" class="text-bw-lightDarkGrey block">{{ t('returnToCardDesc') }}<br>
       <strong>{{ t('returnCost') }} <PriceFormatter :price="orderDataStore.serviceCost.toString()" /></strong>, {{ t('autoRemoved') }}
      </span>
      <span v-else class="text-bw-lightDarkGrey block">{{ t('returnToCardDesc') }}</span>
    </div>
  </div>
</template>

<style scoped>

</style>